<script setup>
defineEmits(['navigate'])
</script>

<template>
  <div class="fw-semibold">
    No priorities found.
    <span
      class="link text-decoration-underline"
      @click="$emit('navigate')"
    >Click here to add a priority.</span>
  </div>
</template>

<style scoped>
.link {
  color: inherit;
  cursor: pointer;
}
</style>
